import { useState } from 'react';
import type { TimeSlot } from '@minibook/shared';
import { AppIcon } from '../../ui/Icon';

type TimeSlotSectionProps = {
  title: string;
  slots: TimeSlot[];
  selectedSlot: TimeSlot | null;
  onSelect: (slot: TimeSlot) => void;
  formatTime: (isoString: string) => string;
  loading?: boolean;
};

export function TimeSlotSection({
  title,
  slots,
  selectedSlot,
  onSelect,
  formatTime,
  loading = false,
}: TimeSlotSectionProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={`booking-time-section ${expanded ? 'expanded' : ''}`}>
      <div className="booking-time-section-header" onClick={() => setExpanded(!expanded)}>
        <span className="booking-time-section-title">{title}</span>
        <AppIcon name="chevronUp" size={16} tone="muted" className="booking-time-section-icon" />
        {loading && <span className="booking-time-section-loading-icon" aria-hidden="true" />}
      </div>
      {expanded && (
        <div className="booking-time-slots-grid">
          {slots.map((slot, index) => {
            const isSelected = selectedSlot?.startAt === slot.startAt;
            return (
              <button
                key={index}
                type="button"
                className={`booking-time-slot ${isSelected ? 'is-selected' : ''} ${loading ? 'is-loading' : ''}`}
                onClick={() => onSelect(slot)}
                disabled={loading}
              >
                {formatTime(slot.startAt)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
